import Code from '@mui/icons-material/Code';
import MobileFriendly from '@mui/icons-material/MobileFriendly';
import Brush from '@mui/icons-material/Brush';
import Speed from '@mui/icons-material/Speed';
import BarChart from '@mui/icons-material/BarChart';
import ShoppingCart from '@mui/icons-material/ShoppingCart';
import { AssignmentTurnedIn } from '@mui/icons-material';
import responsiveIcon from '../../assets/icons/responsive-icon.svg';
import seoIcon from '../../assets/icons/seo-icon.svg';  
import performanceIcon from '../../assets/icons/performance-icon.svg';
import browserIcon from '../../assets/icons/browser-icon.svg';
import securityIcon from '../../assets/icons/security-icon.svg';
import supportIcon from '../../assets/icons/support-icon.svg';

export const serviceCategories = [
  {
    title: "Web Development",
    icon: Code,
    description: "Custom website development with cutting-edge technologies for optimal performance and user experience.",
    services: [
      "Responsive Web Design",
      "Progressive Web Apps (PWA)",
      "Full-Stack Development",
      "API Development & Integration",
      "SEO Optimization"
    ],
    image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=600&q=80",
    color: "#6a1bff"
  },
  {
    title: "Mobile App Development",
    icon: MobileFriendly,
    description: "Native and cross-platform mobile applications that deliver exceptional user experiences across all devices.",
    services: [
      "iOS & Android Development",
      "Cross-Platform Solutions",
      "UI/UX Design",
      "App Store Optimization",
      "Maintenance & Support"
    ],
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=600&q=80",
    color: "#00e5ff"
  },
  {
    title: "UI/UX Design",
    icon: Brush,
    description: "Human-centered design solutions that elevate your digital products and create memorable user experiences.",
    services: [
      "User Research & Testing",
      "Wireframing & Prototyping",
      "Visual Design",
      "Brand Identity",
      "Design Systems"
    ],
    image: "https://images.unsplash.com/photo-1517180102446-f3ece451e9d8?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=600&q=80",
    color: "#ff3d71"
  },
  {
    title: "Performance Optimization",
    icon: Speed,
    description: "Enhance your website's speed and performance to improve user experience and conversion rates.",
    services: [
      "Loading Speed Optimization",
      "Resource Minification",
      "Image Optimization",
      "Database Query Optimization",
      "Core Web Vitals Improvement"
    ],
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=600&q=80",
    color: "#00ff88"
  },
  {
    title: "Digital Marketing",
    icon: BarChart,
    description: "Strategic digital marketing solutions to grow your online presence and reach your target audience.",
    services: [
      "Search Engine Optimization",
      "Social Media Marketing",
      "Content Marketing",
      "Email Marketing",
      "Analytics & Reporting"
    ],
    image: "https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=600&q=80",
    color: "#ffbb00"
  },
  {
    title: "E-Commerce Solutions",
    icon: ShoppingCart,
    description: "Custom e-commerce solutions that drive sales and provide seamless shopping experiences.",
    services: [
      "Custom Online Stores",
      "Payment Gateway Integration",
      "Inventory Management",
      "Mobile E-Commerce",
      "Analytics & Reporting"
    ],
    image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=600&q=80",
    color: "#6a1bff"
  }
];

// export const processSteps = [
//   {
//     title: "Discovery & Planning",
//     description: "We conduct in-depth research to understand your business goals, target audience, and project requirements.",
//     icon: Code,
//     color: "#6a1bff",
//     step: 1
//   },
//   {
//     title: "Design & Prototyping",
//     description: "Our designers create wireframes and interactive prototypes to visualize the user experience and interface.",
//     icon: Brush,
//     color: "#00e5ff",
//     step: 2
//   },
//   {
//     title: "Development & Testing",
//     description: "Our development team transforms designs into functional, responsive, and optimized code with rigorous testing.",
//     icon: MobileFriendly,
//     color: "#00ff88",
//     step: 3
//   },
//   {
//     title: "Deployment & Launch",
//     description: "We ensure smooth deployment, conduct final quality checks, and prepare for a successful launch.",
//     icon: Speed,
//     color: "#ffbb00",
//     step: 4
//   },
//   {
//     title: "Maintenance & Support",
//     description: "Our commitment extends beyond launch with ongoing support, updates, and continuous improvements.",
//     icon: BarChart,
//     color: "#ff3d71",
//     step: 5
//   }
// ];

export const processSteps = [
  {
    title: "Discovery & Planning",
    description: "We conduct in-depth research to understand your business goals, target audience, and project requirements.",
    icon: Code,
    color: "#6a1bff",
    step: 1
  },
  {
    title: "Design & Prototyping",
    description: "Our designers create wireframes and interactive prototypes to visualize the user experience and interface.",
    icon: Brush,
    color: "#00e5ff",
    step: 2
  },
  {
    title: "Development & Testing",
    description: "Our development team transforms designs into functional, responsive, and optimized code with rigorous testing.",
    icon: MobileFriendly,
    color: "#00ff88",
    step: 3
  },
  {
    title: "User Acceptance Testing",
    description: "We validate the product with actual users and stakeholders to ensure it meets all requirements and expectations.",
    icon: AssignmentTurnedIn, // You may want to import this icon or choose another appropriate one
    color: "#ff9500",
    step: 4
  },
  {
    title: "Deployment & Launch",
    description: "We ensure smooth deployment, conduct final quality checks, and prepare for a successful launch.",
    icon: Speed,
    color: "#ffbb00",
    step: 5
  },
  {
    title: "Maintenance & Support",
    description: "Our commitment extends beyond launch with ongoing support, updates, and continuous improvements.",
    icon: BarChart,
    color: "#ff3d71",
    step: 6
  }
];

export const featureItems = [
  {
    title: "Responsive Design",
    description: "Our websites and applications are built to provide an optimal viewing experience across all devices and screen sizes.",
    icon: responsiveIcon,
    color: "#6a1bff"
  },
  {
    title: "SEO Optimization",
    description: "We implement best practices to improve your search engine rankings and drive organic traffic to your website.",
    icon: seoIcon,
    color: "#00e5ff"
  },
  {
    title: "Fast Performance",
    description: "Our solutions are optimized for speed and performance to provide a seamless user experience and improve conversion rates.",
    icon: performanceIcon,
    color: "#00ff88"
  },
  {
    title: "Cross-Browser Compatibility",
    description: "We ensure your website works flawlessly across all major browsers for consistent user experience.",
    icon: browserIcon,
    color: "#ffbb00"
  },
  {
    title: "Secure & Reliable",
    description: "We implement the latest security measures to protect your data and ensure your applications run reliably.",
    icon: securityIcon,
    color: "#ff3d71"
  },
  {
    title: "24/7 Support",
    description: "Our dedicated support team is available around the clock to address any issues and provide assistance.",
    icon: supportIcon,
    color: "#6a1bff"
  }
];